import {
  Button,
  Divider,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import Overlay from 'components/Overlay';
import { AuthContext, CartContext, CateringContext } from 'constants/contexts';
import dayjs from 'dayjs';
import useIsDesktop from 'hooks/useIsDesktop';
import React, { useContext, useEffect, useState } from 'react';
import DateTimePicker from './DateTimePicker';
import DeliveryForm from './DeliverForm';
// import CompanyNameInput from './CompanyNameInput';

function DeliveryInstructionOverlay({ open, onClose }) {
  const cart = useContext(CartContext);
  const catering = useContext(CateringContext);
  const { user } = useContext(AuthContext);
  const [dateTime, setDateTime] = useState(cart.scheduledTime);
  const [headcount, setHeadcount] = useState(catering?.headcount || 1);
  const [recipient, setRecipient] = useState(catering?.recipient);
  // const [company, setCompany] = useState(() => user?.companies?.[user.companies.length - 1] || {});
  const [receiver, setReceiver] = useState('me');
  const [hasSchedulingError, setHasSchedulingError] = useState(cart.schedulingError);
  const isSubmitDisabled = !Number(headcount) || (receiver === 'other' && (!recipient?.name || !recipient?.phone));
  const isDesktop = useIsDesktop();
  useEffect(() => {
    setHeadcount(catering?.headcount || 1);
    setRecipient(catering?.recipient);
    setDateTime(cart.scheduledTime);
  }, [catering, cart.scheduledTime]);

  useEffect(() => {
    if (open) {
      setHasSchedulingError(cart.schedulingError);
    }
  }, [open]);

  const handleUpdateDateTime = (dt) => {
    setDateTime(dt);
    cart.ensureMenuIsAvailable(dt, false)
      .then((failedReason) => {
        setHasSchedulingError(Boolean(failedReason));
      });
  };

  const handleClose = () => {
    setDateTime(dayjs(cart.scheduledTime));
    setHasSchedulingError(false);
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isSubmitDisabled) {
      return;
    }
    // if (company.name && !user.companies.some((c) => normalizeName(c.name) === normalizeName(company.name))) {
    //   if (company.id) {
    //     updateProfile({ company: company.id }).catch(captureException);
    //   } else {
    //     updateProfile({ company_name: company.name }).catch(captureException);
    //   }
    // }
    cart.ensureMenuIsAvailable(dateTime)
      .then((failedReason) => {
        if (failedReason) {
          setHasSchedulingError(true);
        } else {
          catering.set({
            headcount: Math.max(Number(headcount), 1),
            recipient,
            deliveryInstructionsConfirmed: true,
          });
          cart.setScheduledTime(dayjs(dateTime).valueOf());
          handleClose();
        }
      });
    function normalizeName(name) {
      return name.toLowerCase().trim();
    }
  };
  return (
    <Overlay mobileFullScreen open={open} onClose={handleClose} hashKey="catering-instruction">
      <Overlay.Header>
        Order instructions
      </Overlay.Header>
      <Overlay.Content>
        <form onSubmit={handleSubmit}>
          <Typography variant="title-md" mb={1}>Date & Time</Typography>
          <DateTimePicker
            value={dateTime}
            onChange={handleUpdateDateTime}
            variant="alternative"
            hasError={hasSchedulingError}
          />

          <Divider sx={{ my: 2 }} />

          <Typography variant="title-md" mb={2} fontWeight="bold">Who will be accepting this order?</Typography>
          <DeliveryForm receiver={receiver} setReceiver={setReceiver} recipient={recipient} setRecipient={setRecipient} />

          <Divider sx={{ my: 2 }} />

          {/* <Stack mb={2} direction="row" gap={2}>
            <Typography variant="title-md" fontWeight="bold">Company name</Typography>
            <Typography variant="body-md" color="text.disabled">optional</Typography>
          </Stack>
          <CompanyNameInput value={company} onChange={setCompany} />
          <Typography variant="body-md" my={2}>Provide your company name if ordering for a business.</Typography>
          <Divider sx={{ my: 2 }} /> */}
          <Typography variant="title-md" fontWeight="bold">Headcount</Typography>
          <Typography variant="body-md" my={2}>Select the number of guests below. We'll handle the rest!</Typography>
          <TextField
            value={headcount}
            onChange={(e) => setHeadcount(e.target.value)}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="start">
                <Typography variant="label-md">people</Typography>
              </InputAdornment>,
              type: 'number',
            }}
            data-testid="headcount"
          />
        </form>
      </Overlay.Content>
      <Overlay.Actions>
        <Button
          size="large"
          variant="contained"
          disabled={isSubmitDisabled || cart.menuLoading}
          type="submit"
          onClick={handleSubmit}
          fullWidth={!isDesktop}
        >
          Continue
        </Button>
      </Overlay.Actions>
    </Overlay>
  );
}

export default DeliveryInstructionOverlay;
